import React from 'react';
import Link from 'components/Link';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './ThreeDViewCTA.scss';

const ThreeDViewCTA = ({ threeDViewBanner, page, isWapView }) => (
  <Link
    to={threeDViewBanner?.link}
    className={s.threeDViewBanner}
    target={threeDViewBanner?.target || '_blank'}
    ga4Data={
      threeDViewBanner?.ga4Category && [
        {
          event: 'user_click',
          type: threeDViewBanner?.ga4Type || '',
          category: page
            ? `${page}_${threeDViewBanner?.ga4Category}_${
                isWapView ? 'mweb' : 'web'
              }`
            : `${threeDViewBanner?.ga4Category}_${isWapView ? 'mweb' : 'web'}`,
          label: threeDViewBanner?.ga4Label || '',
        },
      ]
    }
  >
    <div className={s.threeDViewBannerLeft}>
      <ImageV2 src={threeDViewBanner?.image} alt={threeDViewBanner?.title} />
    </div>
    <div className={s.threeDViewBannerRight}>
      <h5>
        {threeDViewBanner?.title} <i className={s.arrowIcon} />
      </h5>
      <p>{threeDViewBanner?.subTitle}</p>
    </div>
  </Link>
);

export default ThreeDViewCTA;
